import { render, staticRenderFns } from "./TradePositionsView.vue?vue&type=template&id=284f8b36&scoped=true"
import script from "./TradePositionsView.vue?vue&type=script&lang=ts"
export * from "./TradePositionsView.vue?vue&type=script&lang=ts"
import style0 from "./TradePositionsView.vue?vue&type=style&index=0&id=284f8b36&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "284f8b36",
  null
  
)

export default component.exports